import LoadingSpinner from '@eg/elements/LoadingSpinner';
import React, { FC } from 'react';
import './AppLoader.css';
import styled, { css } from 'styled-components';

interface AppLoaderBlackProps {
  firstLine?: string;
  secondLine?: string;
  show: boolean;
}
const StyledLoadingSpinner = styled(LoadingSpinner)`
  &&&.ee_loading-spinner {
    background: rgba(255, 255, 255, 0.9);
  }
  &&& svg {
    position: relative;
    top: -15vh;
  }
`;

const commonCss = css`
  color: rgba(90, 90, 90);
  position: fixed;
  z-index: 1002;
  left: 50%;
  text-align: center;
  transform: translate(-50%, 0);
`;

const StyledFirstLine = styled.h2`
  ${commonCss}
  top: 39vh;
`;
const StyledSecondLine = styled.h3`
  ${commonCss}
  top: 44vh;
`;

export const AppLoaderBlack: FC<AppLoaderBlackProps> = ({ firstLine, secondLine, show }) => (
  <>
    <StyledLoadingSpinner show={show} />
    {firstLine && show && <StyledFirstLine>{firstLine}</StyledFirstLine>}
    {secondLine && show && <StyledSecondLine>{secondLine}</StyledSecondLine>}
  </>
);
